import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core'
import VerticalLinearStepper from './VerticalLinearStepper'
import LinearProgress from './LinearProgress'
import MessageDialog from './MessageDialog'
import TermsOfServiceDialog from './TermsOfServiceDialog'

const useStyles = makeStyles({
  root: {
    boxSizing: 'border-box',
    padding: 16,
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    justifyContent: 'center',
    color: '#818284',
    fontFamily: 'Montserrat',
    paddingLeft: 50,
  },
  title: {
    fontSize: 28,
  },
  subTitle: {
    fontSize: 16,
  },
})


export default function UploadSection(props) {
  const classes = useStyles()
  const { app: exhibit, api, goToRedirect } = props

  const [saving, setSaving] = useState(false)
  const [messageDialogOpen, setOpenDialog] = useState(false)
  const [addContent, setAddContent] = useState(false)
  const [resetContent, setResetContent] = useState(false)
  const [openToSDialog, setOpenToSDialog] = useState(false)


  const handleSave = async (data) => {
    setResetContent(false)
    setSaving(true)

    if (data.year) data.year = parseInt(data.year)
    if (data.month) data.month = parseInt(data.month)
    if (data.day) data.day = parseInt(data.day)

    const { label, coords } = data.location

    const ugcModel = api.ugc().newUgc(exhibit, [], data.email, data.name, data.caption, data.year, data.month, data.day, data.desc, label, coords.lat, coords.lng, data.assetId)

    const { error: savedError } = await api.ugc().save(ugcModel)
    if (savedError) return

    setSaving(false)
    setOpenDialog(true)
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
    setAddContent(false)
    setResetContent(true)
    goToRedirect()
  }

  const handleAddContent = () => {
    setOpenDialog(false)
    setAddContent(true)
    setResetContent(true)
  }

  const handleClickedTermsofService = () => {
    setOpenToSDialog(true)
  }

  return (
    <div className={classes.root}>
      <div className={classes.title}>Help us to tell this story</div>
      <div className={classes.subTitle}>
        Please submit your photos and stories
      </div>
      <VerticalLinearStepper
        api={api}
        app={exhibit}
        save={handleSave}
        addContent={addContent}
        resetContent={resetContent}
        clickedTermsofService={handleClickedTermsofService}
      />
      {saving && <LinearProgress />}
      <MessageDialog
        open={messageDialogOpen}
        add={handleAddContent}
        close={handleCloseDialog}
      />

      <TermsOfServiceDialog
        app={exhibit}
        api={api}
        open={openToSDialog}
        close={() => setOpenToSDialog(false)}
      />
    </div>
  )
}
